import styled from 'styled-components'
import { BREAKPOINTS, COLORS } from '~/shared/constants/uiConstants'

export const Styles = {
  Wrapper: styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: center;
    padding: 0 16px;
    max-width: ${BREAKPOINTS[375]}px;
    margin: 0 auto;
  `,

  StepItem: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    flex: 0 0 auto;
  `,

  StepLabel: styled.span<{ $active: boolean }>`
    font-size: 11px;
    line-height: 14px;
    text-align: center;
    max-width: 64px;
    color: ${({ $active }) => ($active ? COLORS.BLACK : '#626262')};
    font-weight: ${({ $active }) => ($active ? 700 : 400)};
  `,

  StepCircle: styled.div<{ $status: 'done' | 'active' | 'idle' }>`
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 600;
    flex-shrink: 0;

    background: ${({ $status, theme }) => {
      if ($status === 'done') return theme.colors.strongTextColor
      if ($status === 'active') return '#E9E9E9'

      return '#E9E9E9'
    }};

    border: ${({ $status, theme }) => {
      if ($status === 'done') return `2px solid ${theme.colors.strongTextColor}`
      if ($status === 'active') return '2px solid #E9E9E9'

      return '2px solid #E9E9E9'
    }};

    color: ${({ $status }) => {
      if ($status === 'done') return '#ffffff'
      if ($status === 'active') return '#000000'
      return '#9ca3af'
    }};
  `,

  Connector: styled.div<{ $filled: boolean }>`
    flex: 1;
    height: 2px;
    margin-bottom: 16px;
    margin-left: 8px;
    margin-right: 8px;
    background: ${({ $filled, theme }) =>
      $filled ? theme.colors.strongTextColor : '#e5e7eb'};
    min-width: 16px;
  `,
} as const
